<template>
  <div class="app-container">
    <div class="screen-search">
      <el-search
        :form-item-data="formItemData"
        :rules="rules"
        :is-show.sync="isShow"
        @onSubmitSingle="onSubmitSingle"
        @onSubmitMulti="onSubmitMulti">
        <div class="approval-process">
          <el-button :class="[isFocus ? 'active disposal' : '']" size="medium" type="text" @click="handleDisposal">待办({{ disposalNum }})
          </el-button>
          <el-button :class="[isFocus ? '' : 'active processed']" size="medium" type="text" @click="handleProcessed">
            已办
          </el-button>
        </div>
        <el-button class="agent-btn"><i class="icon-ccui-user"/>指定代理</el-button>
      </el-search>
    </div>

    <!-- ————————————————————————-->
    <div class="table-wapper">
      <el-popover
        v-model="visible"
        placement="bottom-start"
        title="标题"
        width="200"
        trigger="manual"
      >
        <el-checkbox-group v-model="checkboxVal">
          <template v-for="(item,index) in formTheadOptions">
            <el-checkbox :key="index" :label="item">{{ item }}</el-checkbox>
          </template>
        </el-checkbox-group>
        <div slot="reference" class="hidden-btn"/>
      </el-popover>
      <el-table
        ref="multipleTable"
        :data="tableData"
        :key="key"
        :default-sort="{prop: 'id', order: 'descending'}"
        border
        fit
        highlight-current-row
        style="width: 100%"
        @row-click="jumpToDetail"
        @select-all="handleCheckAllChange"
        @select="handleCheckChange"
      >
        <el-table-column type="selection" width="55"/>
        <el-table-column v-for="fruit in formThead" :key="fruit" :label="fruit">
          <template slot-scope="scope">{{ scope.row[fruit] }}
          </template>
        </el-table-column>
        <el-table-column :render-header="renderLastHeader" width="36"/>
      </el-table>
      <div class="table-footer">
        <div v-show="isSelection" class="operation">
          <el-button size="mini" type="default-bottom" @click="handleApproval">批量审批</el-button>
          <el-button size="mini" type="default-bottom" @click="handleExport">导出</el-button>
        </div>
        <div class="paging">
          <el-pagination
            :total="1000"
            :current-page.sync="currentPage3"
            :page-size="100"
            background
            layout="prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"/>
          <el-button size="medium" type="default-bottom">确定</el-button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
// import { getList } from '@/api/approve-contract'
import {
  Popover,
  CheckboxGroup,
  Checkbox,
  Pagination,
  Button
} from 'ccui'

const defaultFormThead = [
  '序号',
  '统一信用代码',
  '供应商名称',
  '简称',
  '类型',
  '所在省/地区',
  '申请类型',
  '审批状态',
  '操作'
]
export default {
  components: {
    Popover,
    CheckboxGroup,
    Checkbox,
    Pagination,
    Button
  },
  data() {
    return {
      code: [],
      isFocus: true,
      isSelection: false,
      disposalNum: 0,
      currentPage1: 5,
      currentPage2: 5,
      currentPage3: 5,
      currentPage4: 4,
      formItemData: [
        {
          id: '1',
          type: 'input',
          placeHolder: '供应商名称',
          name: 'contractName',
          label: '供应商名称',
          value: '',
          outputValue: ''
        },
        {
          id: '2',
          type: 'select',
          placeHolder: '类型',
          name: 'contractNum',
          label: '类型',
          value: '',
          outputValue: '',
          option: [
            {
              value: '1',
              label: '类型1A'
            }, {
              value: '2',
              label: '类型2B'
            }, {
              value: '3',
              label: '类型1C'
            }, {
              value: '4',
              label: '类型1D'
            }, {
              value: '5',
              label: '类型1E'
            }
          ]
        }, {
          id: '3',
          type: 'input',
          placeHolder: '所在省/地区',
          name: 'managingUnit',
          label: '所在省/地区',
          value: '',
          outputValue: ''
        }, {
          id: '4',
          type: 'input',
          placeHolder: '申请类型',
          name: 'contractFirst',
          label: '申请类型',
          value: '',
          outputValue: ''
        }, {
          id: '5',
          type: 'input',
          placeHolder: '审批状态',
          name: 'contractLast',
          label: '审批状态',
          value: '',
          outputValue: ''
        }
      ],
      rules: {
        contractName: [
          { required: true, message: '请输入活动名称', trigger: 'blur' },
          { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ]
      },
      value: '',
      k: 1,
      isShow: false,
      input: '',
      // 分割线——————————————————————————————
      isIndeterminate: false,
      visible: false,
      checkAll: false,
      tableData: [],
      key: 1, // table key
      formTheadOptions: [
        '序号',
        '统一信用代码',
        '供应商名称',
        '简称',
        '类型',
        '所在省/地区',
        '申请类型',
        '审批状态',
        '操作'
      ],
      checkboxVal: defaultFormThead, // checkboxVal
      formThead: defaultFormThead // 默认表头 Default header
    }
  },

  watch: {
    checkboxVal(valArr) {
      this.formThead = this.formTheadOptions.filter(
        i => valArr.indexOf(i) >= 0
      )
      this.key = this.key + 1 // 为了保证table 每次都会重渲 In order to ensure the table will be re-rendered each time
    },
    $route(to, from) {
      this.fetchDate()
      console.log('to from')
      console.log(to)
      console.log(from)
    }
  },

  created() {
    this.getList()
  },

  methods: {
    handleApproval() {
      console.log('批量审批', this.code)
    },
    handleExport() {
      console.log('导出', this.code)
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.getList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.getList()
    },
    onSubmitMulti(obj) {
      console.log('多字段查询')
      console.log(obj)
    },
    onSubmitSingle(obj) {
      console.log('单字段查询')
      console.log(obj)
    },
    jumpToDetail(row, col, e) {
      console.log('wwwwwwwwwww')
      console.log(row)
      console.log(col)
      console.log(e)
      if (row.id) {
        this.$router.push('/approval/contract/contract-detail/' + row.id)
      } else {
        this.$message('查看详情请点击有id的行')
      }
    },
    searchShow() {
      // this.isShowVal = !this.isShowVal;
      this.isShow = !this.isShow
    },
    onSubmit() {
      console.log(this.formInline)
      console.log(this.type.value)
      console.log(this.price.value)
      console.log(this.approval.value)
    },
    onClear() {
      for (var i in this.formInline) {
        this.formInline[i] = ''
        break
      }
      this.type.value = ''
      this.price.value = ''
      this.approval.value = ''
    },
    // 分割线————————————————————
    handleDisposal() {
      this.isFocus = true
      console.log(111)
      this.getList()
    },
    handleProcessed() {
      this.isFocus = false
      console.log(222)
      this.getList()
    },

    getList() {
      getList({
        pageNo: 3,
        pageSize: 15
      }).then(res => {
        // console.log('xpppppp', res.data)
        this.tableData = res.data.data
        this.disposalNum = res.data.data.length
      })
    },
    fetchDate() {
      console.log('路由发生变化了')
    },
    handleCheckAllChange(val) {
      this.isIndeterminate = false
      console.log('xxxxxxx', val)
      if (val.length) {
        this.isSelection = true
      } else {
        this.isSelection = false
      }
      if (typeof val === 'boolean') {
        if (val) {
          // console.log('xxxxxx', this.toggleSelection)
          this.toggleSelection(this.tableData)
        } else {
          this.toggleSelection([])
        }
      } else {
        this.checkAll = val.length !== 0
      }
    },
    handleCheckChange(val) {
      console.log('handleCheckChange')
      // console.log('fffffff', val)
      const arr = []
      for (let i = 0; i < val.length; i++) {
        // console.log('lllllll', val[i].id)
        // console.log(this.code)
        arr.push(val[i].id)
      }
      // console.log('ppppp', arr)
      this.code = arr
      if (val.length) {
        this.isSelection = true
      } else {
        this.isSelection = false
      }
      if (val.length > 0 && val.length < 2) {
        this.isIndeterminate = true
      } else if (val.length === 2) {
        this.checkAll = true
        this.isIndeterminate = false
      } else {
        this.checkAll = false
        this.isIndeterminate = false
      }
    },
    toggleSelection(rows) {
      console.log('ttttttt', this.$refs.multipleTable)
      this.$refs.multipleTable.clearSelection()
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      }
    },
    renderLastHeader(h, { column, $index }) {
      column.minWidth = 55
      column.realWidth = 55
      return h('span', {}, [
        h('svg-icon', {
          props: {
            iconClass: 'setup'
          },
          on: {
            click: () => {
              this.showControlPanel()
            }
          },
          slot: 'reference'
        })
      ])
    },
    showControlPanel() {
      this.visible = !this.visible
    },
    sizeChangeHandler(e) {
    },
    pageChangeHandler(e) {
    }
  }
}
</script>

<style lang="scss">
  .el-tabel {
    margin-bottom: 70px;
  }

  .app-container {
    margin-top: 12px;
  }

  .table-wapper {
    position: relative;

    .el-table {
      .el-table__header-wrapper {
        background: red;

        .has-gutter {
          th {
            border-right: none;
            color: rgba(74, 74, 74, 1);
          }
        }
      }

      .el-table__body-wrapper {
        .el-table__row {
          td {
            border-right: none;
          }
        }
      }
    }

    .hidden-btn {
      position: absolute;
      top: 16px;
      right: 5px;
    }

    .table-footer {
      height: 70px;
      line-height: 70px;
      background-color: #ffffff;
      z-index: 5;
      width: 100%;
      .operation {
        float: left;

        button {
          background: rgba(246, 246, 246, 1);
          border: 1px solid rgba(221, 221, 221, 1);
        }
      }

      .paging {
        float: right;
        padding-top: 20px;
        padding-right: 20px;
        height: 70px;
        display: flex;
        /*justify-content: space-between;*/
        .el-button{
          width:65px;
          height:30px;
          background:rgba(246,246,246,1);
          border:1px solid rgba(221,221,221,1);
          display: block;
          span{

          }
        }
      }
    }
  }

  /*————————————————————————————*/
  .screen-search {
    background: #ffffff;
    /*background: red;*/
    align-items: center;
    height: 66px;
    line-height: 66px;
    .el-search-wrapper {
      float: right;
      width: 100%;
      border-top: 1px solid rgba(241,241,241,1);
      .el-popper {
        margin: 0;
        padding: 0;
        border: none;
        border-radius: 0;
        .el-form {
          .el-row {
            .search-buttom {
              margin-left: 240px;
            }
          }
        }
      }

      .el-row {
        /*float: right;*/
        .agent-btn {
          width: 93px;
          height: 30px;
          background: rgba(56, 136, 255, 1);
          border-radius: 2px;
          color: rgba(255, 255, 255, 1);
        }

        .approval-process {
          position: absolute;
          left: 0;

          .el-button {
            color: rgba(74, 74, 74, 1);
          }

          .active {
            color: #004898;
            border-bottom: 2px solid rgba(7, 91, 186, 1);
            border-radius: 0;
          }
        }
      }
    }

    .el-search {
      margin-top: 20px;

      .search-btn {
        background: rgba(0, 0, 0, 0);
      }
    }

    .el-input__inner {
      background: rgba(0, 0, 0, 0);
    }
  }

</style>

